const types = {
    IDVERIFICATION_CHANGE_STEP: 'IDVERIFICATION_CHANGE_STEP',
    IDVERIFICATION_MANUAL_VERIFICATION_REQUEST_SENT: 'IDVERIFICATION_MANUAL_VERIFICATION_REQUEST_SENT',
    IDVERIFICATION_PHOTO_APPROVED: 'IDVERIFICATION_PHOTO_APPROVED',
    IDVERIFICATION_PHOTO_REJECTED: 'IDVERIFICATION_PHOTO_REJECTED',
    IDVERIFICATION_PHOTO_RETAKE_COMPLETED: 'IDVERIFICATION_PHOTO_RETAKE_COMPLETED',
    IDVERIFICATION_REQUEST_WENT_WRONG: 'IDVERIFICATION_REQUEST_WENT_WRONG',
    IDVERIFICATION_SET_ID_VERIFICATION_STATUS: 'IDVERIFICATION_SET_ID_VERIFICATION_STATUS',
    IDVERIFICATION_SIMILARITY_UPDATE: 'IDVERIFICATION_SIMILARITY_UPDATE',
    IDVERIFICATION_TAKE_PHOTO: 'IDVERIFICATION_TAKE_PHOTO',
};

/**
 * These constants are written in lowercase letters so that the value of the
 * constant matches the key of the translated message in Webtranslateit.
 *
 * As the translation keys are in camelCase and start with a lowercase letter,
 * these constants follow the same format.
 */
const errorMessageTypes = {
    loading: 'loading',
    none: 'none',
    noFacesDetected: 'noFacesDetected',
    wrongPose: 'wrongPose',
    tooDark: 'tooDark',
    tooBlurry: 'tooBlurry',
    requestWentWrong: 'requestWentWrong',
};

const similarityMessageTypes = {
    PENDING_AUTOMATIC: 'PENDING_AUTOMATIC',
    PENDING_MANUAL: 'PENDING_MANUAL',
    APPROVED: 'APPROVED',
    REJECTED: 'REJECTED',
};

const stepTypes = {
    PHOTO: 'PHOTO',
    ID_CARD: 'ID_CARD',
    SIMILARITY: 'SIMILARITY',
};

const photoVerificationType = {
    PHOTO: 'photo',
    ID_CARD: 'id-card',
    SIMILARITY: 'similarity',
};

function takePhoto() {
    return { type: types.IDVERIFICATION_TAKE_PHOTO };
}

function photoApproved() {
    return { type: types.IDVERIFICATION_PHOTO_APPROVED };
}

function photoRejected(verificationStatus) {
    return { type: types.IDVERIFICATION_PHOTO_REJECTED, verificationStatus };
}

function changeStep(newStep) {
    const verificationStatus = newStep === stepTypes.SIMILARITY
        ? similarityMessageTypes.PENDING_AUTOMATIC
        : null;

    return {
        type: types.IDVERIFICATION_CHANGE_STEP,
        newStep,
        verificationStatus,
    };
}

function similarityUpdate(verificationStatus) {
    return { type: types.IDVERIFICATION_SIMILARITY_UPDATE, verificationStatus };
}

function setIdVerificationStatus(idVerificationStatus) {
    return {
        type: types.IDVERIFICATION_SET_ID_VERIFICATION_STATUS,
        idVerificationStatus,
        idVerificationStatusSetTime: Date.now(),
    };
}

function requestWentWrong() {
    return { type: types.IDVERIFICATION_REQUEST_WENT_WRONG };
}

const idVerificationActions = {
    setManualIdVerificationRequestSent(isSent) {
        return { type: types.IDVERIFICATION_MANUAL_VERIFICATION_REQUEST_SENT, isSent };
    },

    setPhotoRetakeCompleted(isCompleted) {
        return { type: types.IDVERIFICATION_PHOTO_RETAKE_COMPLETED, isCompleted };
    },
};

export {
    changeStep,
    errorMessageTypes,
    photoApproved,
    photoRejected,
    photoVerificationType,
    requestWentWrong,
    setIdVerificationStatus,
    similarityMessageTypes,
    similarityUpdate,
    stepTypes,
    takePhoto,
    types,
};

export default idVerificationActions;
